import { loadSites, unloadSites } from 'modules/sites/actions'
import { ACCOUNTS_LOADED } from 'modules/accounts'
import { SIGN_OUT_SUCCESS } from 'modules/auth'

export default ({ dispatch, getState }) => next => action => {
  const result = next(action)

  if (typeof action === 'object') {
    if (action.type === ACCOUNTS_LOADED) {
      dispatch(loadSites())
    }
    else if (action.type === SIGN_OUT_SUCCESS) {
      dispatch(unloadSites())
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/sites.js